import axios from "axios";
import TokenService from "./token.service";

let APP_URL = window.location.hostname;
if (APP_URL.includes('www.'))
        APP_URL = APP_URL.slice(4, undefined);

const instance = axios.create({
  baseURL: "https://api." + APP_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/admin/api/v1/authenticate" && originalConfig.url !== "/admin/api/v1/refresh-token" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.put("/admin/api/v1/refresh-token", {
            sub: TokenService.getUser().userInfo.sub,
            refreshToken: TokenService.getLocalRefreshToken(),
          });

          const { accessToken, refreshToken } = rs.data.data;
          TokenService.updateLocalAccessToken(accessToken, refreshToken);

          return instance(originalConfig);
        } catch (_error) {
          TokenService.removeUser();
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;